<template>
  <div class="content card">
    <div>
      <span class="">Brand</span>
      <div class="grid grid-cols-2 gap-3 mt-3">
        <BrandItem v-for="(item,index) in myBrands" :key="item.id"
            :brand-url="item.brandPicture"
            :is-add="item.isAdd"
            :selected="item.selected"
            @onAddBrand="onAddBrand"
            @onSelectBrand="onSelectBrand(item,index)"
            @onEdit="onEditBrand(item,index)"
            :is-pending="item.status === 0"/>
      </div>

    </div>
    <PopupBrandInfo v-model="showBrandPopup"
        :is-add="isAddBrand"
        :button-text="submitText"
        :brand-info="selectedBrand"
        show-delete
        delete-text="Delete"
        @onDeleteClick="showDeleteTips =true"
        @onUpdateBrandList="onUpdateBrandList"
        @onUpdateBrandInfo="onUpdateBrandInfo"/>
    <DialogTips v-model="showDeleteTips"
        title="Delete Brand"
        message="Delete this Brand?"
        left-text="Cancel"
        right-text="Confirm"
        @onLeftClick="showDeleteTips = false"
        @onRightClick="onDeleteBrand"/>
    <CustomizationBottomOperate show-edit :disabled="disableEdit" text="Enter" @onBrandEdit="onEditBrand"
        @onNext="onNext"/>
  </div>
</template>

<script>
import produce from "@/api/produce";
import BrandItem from "@/components/customization/BrandItem.vue";
import CustomizationBottomOperate from "@/components/customization/CustomizationBottomOperate.vue";
import log from "@/util/log";
import bus from "@/util/EventBus";
import PopupBrandInfo from "@/components/customization/PopupBrandInfo.vue";
import DialogTips from "@/components/DialogTips.vue";

export default {
  name: "Brand",
  components: { DialogTips, PopupBrandInfo, CustomizationBottomOperate, BrandItem },
  props: {},
  data() {
    return {
      myBrands: null,
      currentSelected: -1,
      showBrandPopup: false,
      isAddBrand: false,
      submitText: "Submit",
      showDeleteTips: false
    };
  },
  methods: {
    async loadData() {
      const myBrands = await produce.myBrands();
      myBrands.forEach((item) => {
        item.selected = false;
      });
      myBrands.push({
        id: 0,
        isAdd: true
      });

      this.myBrands = myBrands;
    },
    onSelectBrand(item, index) {
      const myBrands = this.myBrands;
      if (this.currentSelected !== -1) {
        myBrands[this.currentSelected].selected = false;
      }
      myBrands[index].selected = true;
      this.currentSelected = index;
    },
    onAddBrand() {
      if (this.currentSelected !== -1) {
        this.myBrands[this.currentSelected].selected = false;
      }
      this.currentSelected = -1;
      this.submitText = "Submit";
      this.isAddBrand = true;
      this.showBrandPopup = true;
    },
    onEditBrand() {
      this.isAddBrand = false;
      log("onBrandEdit");
      this.submitText = "Apply";
      this.showBrandPopup = true;
    },
    async onDeleteBrand() {
      console.log(`onDeleteBrand`);
      try {
        const brand = this.myBrands[this.currentSelected];
        const resp = await produce.deleteBrand({ id: brand.id }, true);
        if (resp.code === 1500) {
          this.$toast({
            type: "fail",
            message: resp.message
          });
          return;
        }
        this.$toast({
          type: "success",
          message: resp.message
        });

        this.myBrands.splice(this.currentSelected, 1);

        this.showDeleteTips = false;
        this.showBrandPopup = false;
      } catch (e) {
        this.$toast({
          type: "fail",
          message: e
        });
      }

    },
    onNext() {
      log("onNext");
      this.$router.push({
        path: "/customization/product",
        query: {
          brandId: this.myBrands[this.currentSelected].id
        }
      });
    },
    onUpdateBrandInfo(brandInfo) {
      const index = this.myBrands.findIndex(item => item.id === brandInfo.id);
      if (index === -1) {
        return;
      }

      log(`Update brand info ${JSON.stringify(brandInfo)}`);
      this.myBrands[index] = brandInfo;
    },
    async onUpdateBrandList() {
      await this.loadData();
    }

  },
  computed: {
    disableEdit() {
      return this.currentSelected === -1 || this.myBrands[this.currentSelected].status === 0;
    },
    selectedBrand() {
      if (this.currentSelected === -1) {
        return {
          brandPicture: require("@/assets/icons/v2/ic_add_brand_default.png"),
          brandName: ""
        };
      }
      return this.myBrands[this.currentSelected];
    }
  },
  async mounted() {
    setTimeout(() => {
      bus.$emit("stepChange", 0);
    });
    await this.loadData();
  }
};
</script>


<style scoped lang="less">

.content {
  height: auto;
  overflow-y: auto;
  background: white;
}

.card {
  //bg-white default-radius pl-4 pr-4 pt-2.5 pb-2.5
  background: white;
  border-radius: 12px;
  padding: 12px 16px;

}
</style>